/**
 * Cross-fades the hero banners. The copy stays where it is; only the picture
 * behind it changes.
 */
class YcHeroSlides extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.yc-mhero__img'));
    if (this.slides.length < 2) return;

    this.interval = Number(this.dataset.interval) || 7000;
    this.index = 0;

    // A picture changing on its own is motion; hold the first one instead.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Nothing to look at while the section is off screen.
    this.observer = new IntersectionObserver(
      ([entry]) => (entry.isIntersecting ? this.#start() : this.#stop()),
      { threshold: 0.1 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.#stop();
    this.observer?.disconnect();
  }

  #start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.#advance(), this.interval);
  }

  #stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  #advance() {
    this.slides[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.slides.length;
    const next = this.slides[this.index];
    // A lazy banner that has never been on screen would fade in from blank.
    next.loading = 'eager';
    next.classList.add('is-active');
  }
}

if (!customElements.get('yc-hero-slides')) customElements.define('yc-hero-slides', YcHeroSlides);
